import type { ChangeEvent, FunctionComponent } from 'react';
import { useCallback } from 'react';
import { ClearableTextInput } from '@george-labs.com/design-system';

interface FeatureListSearchInputProps {
    value: string;
    onChange: (searchTerm: string) => void;
}

export const FeatureListSearchInput: FunctionComponent<FeatureListSearchInputProps> = ({
    value,
    onChange,
}) => {
    const handleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value),
        [onChange],
    );

    const handleClear = useCallback(() => onChange(''), [onChange]);

    return (
        <ClearableTextInput
            placeholder="Search"
            value={value}
            onChange={handleChange}
            onClear={handleClear}
        />
    );
};
